// De firebase-namespace zoals de app hem in firebase 8 kende: ALLE onderdelen
// geregistreerd. In 8 deed `import firebase from 'firebase'` dat vanzelf; in de
// compat-laag van 9+ registreert een onderdeel zich pas als het geïmporteerd
// wordt. Zonder dit bestand hangt `firebase.firestore.FieldValue` af van de
// vraag of config.js toevallig al geladen is -- en in elke test die config.js
// mockt is dat niet zo. Importeer firebase daarom altijd hiervandaan, nooit
// rechtstreeks uit 'firebase/compat/app'.
// AI-CONTEXT: See docs/features/mfa-totp.md
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/functions'

export default firebase
